import { GPSPosition } from "../GPS-position";
import { COFRAC } from "./cofrac";
import { EPrelevementLacType } from "./enum/prelevement-lac-type";
import { SupportSediment } from "./support-sediment";

export class PrelevementLac {
    SampleCode: string;
    Type: EPrelevementLacType;
    Date: Date;
    Materiel: number;
    ReferenceMateriel: string;
    Profondeur: number;
    PlageProfondeurDebut: number;
    PlageProfondeurFin: number;
    Epaisseur: number;
    NbFlacon: number;
    TemperatureGlaciere: number;
    Comment: string;

    COFRAC: COFRAC = new COFRAC();
    GPSPosition: GPSPosition = new GPSPosition();
    /** Only used with Prel Sediment */
    SupportSediment?: SupportSediment = new SupportSediment();

    constructor() {

    }

    static mapFromJSON(json: any): PrelevementLac {
        const p = new PrelevementLac();
        p.SampleCode = json.sampleCode;
        p.Type = json.type;
        p.Date = json.date
        p.Materiel = json.materiel;
        p.ReferenceMateriel = json.referenceMateriel;
        p.Profondeur = json.profondeur;
        p.PlageProfondeurDebut = json.plageProfondeurDebut;
        p.PlageProfondeurFin = json.plageProfondeurFin;
        p.Epaisseur = json.epaisseur;
        p.NbFlacon = json.nbFlacon;
        p.TemperatureGlaciere = json.temperatureGlaciere;
        p.Comment = json.comment;

        /** Remove Support Child for non Sediment Sampling */
        if (p.Type !== EPrelevementLacType.PrelSediment) {
            p.SupportSediment = undefined;
        }

        if (json.cofrac) {
            p.COFRAC = COFRAC.mapFromJSON(json.cofrac);
        }
        if (json.gpsPosition) {
            p.GPSPosition = GPSPosition.mapFromJSON(json.gpsPosition);
        }
        if (json.supportSediment) {
            p.SupportSediment = SupportSediment.mapFromJSON(json.supportSediment);
        }
        return p;
    }
}